import { getClient } from "./client";
import type { ApiPlayerDetails } from "./shared";

export const getPlayers = () =>
  getClient().get("/api/players").json<ApiPlayerDetails[]>();
